/* ==========================================================================
   ALL YU — v3 theme behavior (Shopify). Vanilla JS, no dependencies.
   Cart: Shopify AJAX API + bundled section rendering — the drawer HTML comes
   back from Shopify on every add/change, so prices and savings are always right.
   ========================================================================== */
(() => {
  'use strict';
  const A = window.ALLYU || {};
  const R = A.routes || {};
  const $ = (s, c = document) => (c ? c.querySelector(s) : null);
  const $$ = (s, c = document) => (c ? Array.from(c.querySelectorAll(s)) : []);
  const DRAWER = 'cart-drawer';
  const CALM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------ money */
  function money(cents) {
    const n = Number(cents) || 0;
    const fix = (p, t, d) => { const [a, b] = (n / 100).toFixed(p).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? d + b : ''); };
    const fmt = A.moneyFormat || '${{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(2, ',', '.'), amount_no_decimals: fix(0, ',', '.'),
      amount_with_comma_separator: fix(2, '.', ','), amount_no_decimals_with_comma_separator: fix(0, '.', ','),
      amount_with_apostrophe_separator: fix(2, "'", '.'), amount_with_space_separator: fix(2, ' ', ','),
      amount_no_decimals_with_space_separator: fix(0, ' ', ',')
    }[k] || fix(2, ',', '.')));
  }
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  function priceHTML(price, compare, pdp) {
    const sale = compare && compare > price;
    if (pdp) return `<span class="price__now">${money(price)}</span>${sale ? `<s>${money(compare)}</s>${A.saleLabel ? `<span class="tag">${esc(A.saleLabel)}</span>` : ''}` : ''}`;
    return `<span class="price">${sale ? `<s>${money(compare)}</s>` : ''}<span class="price__now">${money(price)}</span></span>`;
  }

  /* ------------------------------------------------------------------ toast */
  let toastT;
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    $('#toastMsg', t).textContent = msg; t.classList.add('is-show');
    clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove('is-show'), 2800);
  }

  /* ------------------------------------------------------------- overlays */
  /* One layer (cart, search, menu, size guide) at a time. Closed layers are inert so they can't take
     keyboard focus; an open layer makes the rest of the page inert so focus stays inside it, and closing
     it returns focus to whatever opened it. */
  const LAYERS = ['#cart', '#search', '#mnav', '#sizeModal'];
  const KEEP = ['overlay', 'toast'];
  const open = [], openers = new Map(), inerted = new Map();
  const lock = () => document.body.classList.toggle('no-scroll', open.length > 0);
  function isolate(el) {
    const list = [];
    for (let node = el; node && node !== document.body; node = node.parentElement) {
      const parent = node.parentElement; if (!parent) break;
      Array.from(parent.children).forEach(sib => {
        if (sib === node || sib.inert || KEEP.includes(sib.id) || sib.tagName === 'SCRIPT' || sib.tagName === 'STYLE') return;
        sib.inert = true; list.push(sib);
      });
    }
    return list;
  }
  function closeLayer(el, silent) {
    if (!el || !open.includes(el)) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); el.inert = true;
    open.splice(open.indexOf(el), 1);
    (inerted.get(el) || []).forEach(n => { n.inert = false; }); inerted.delete(el);
    if (!open.some(x => x.id === 'cart' || x.id === 'mnav')) { const o = $('#overlay'); if (o) o.classList.remove('is-open'); }
    lock();
    const back = openers.get(el); openers.delete(el);
    if (!silent && back && back.focus) back.focus();
    if (el.id === 'mnav') { const mb = $('#menuBtn'); if (mb) mb.setAttribute('aria-expanded', 'false'); }
  }
  function openLayer(el, focusSel, from) {
    if (!el || open.includes(el)) return;
    let opener = from || document.activeElement;
    open.slice().forEach(x => { if (openers.get(x)) opener = openers.get(x); closeLayer(x, true); });
    openers.set(el, opener);
    el.inert = false; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    open.push(el); inerted.set(el, isolate(el));
    if (el.id === 'cart' || el.id === 'mnav') { const o = $('#overlay'); if (o) o.classList.add('is-open'); }
    lock(); const f = focusSel ? $(focusSel, el) : null; if (f) setTimeout(() => f.focus(), 60);
  }
  const initLayers = () => LAYERS.forEach(sel => { const el = $(sel); if (el) el.inert = true; });

  /* ------------------------------------------------------------------- cart */
  function setCount(n) {
    const c = $('#cartCount'); if (!c) return;
    c.textContent = n; c.hidden = !n;
    const btn = $('#cartBtn'); if (btn) btn.setAttribute('aria-label', n ? `Open cart, ${n} item${n === 1 ? '' : 's'}` : 'Open cart');
    c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
  }
  function swapDrawer(html) {
    const cur = $('#cart'); if (!html || !cur) return;
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#cart');
    if (!fresh) return;
    const wasOpen = cur.classList.contains('is-open');
    /* keep keyboard / screen-reader users on the same control after the drawer re-renders */
    const act = document.activeElement, hadFocus = wasOpen && cur.contains(act);
    const fLine = hadFocus ? act.closest('.line') : null, fKey = fLine ? fLine.dataset.key : null, fLabel = hadFocus ? act.getAttribute('aria-label') : null;
    cur.innerHTML = fresh.innerHTML;
    cur.className = fresh.className + (wasOpen ? ' is-open' : '');
    cur.dataset.count = fresh.dataset.count;
    setCount(parseInt(fresh.dataset.count, 10) || 0);
    if (hadFocus) {
      const ln = fKey ? $$('.line', cur).find(l => l.dataset.key === fKey) : null;
      const back = ln && fLabel ? $$('[aria-label]', ln).find(x => x.getAttribute('aria-label') === fLabel) : null;
      const f = back || $('#cartClose', cur); if (f) f.focus();
    }
  }
  async function cartPost(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: [DRAWER], sections_url: location.pathname }))
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Couldn’t update the cart');
    return data;
  }
  const onCartPage = () => document.body.dataset.page === 'cart';
  async function refreshDrawer() {
    try {
      const j = await fetch(`${R.root || '/'}?sections=${DRAWER}`, { headers: { Accept: 'application/json' } }).then(r => r.json());
      if (j && j[DRAWER]) swapDrawer(j[DRAWER]);
    } catch (e) { /* keep what's showing */ }
  }
  async function afterCartChange(data) {
    if (onCartPage()) { location.reload(); return; }          /* the cart page's own form must never go stale */
    if (data && data.sections && data.sections[DRAWER]) swapDrawer(data.sections[DRAWER]);
    else await refreshDrawer();                                 /* Shopify can return a null section */
  }
  async function addToCart(items) {
    const data = await cartPost(R.cartAdd, { items });
    await afterCartChange(data);
    return data;
  }
  async function changeLine(key, quantity) {
    const data = await cartPost(R.cartChange, { id: key, quantity });
    await afterCartChange(data);
    return data;
  }
  function wireCart() {
    const drawer = $('#cart'); if (!drawer) return;
    const show = from => { if (onCartPage()) { location.reload(); return; } openLayer(drawer, '#cartClose', from && from.nodeType === 1 ? from : null); };
    const hide = () => closeLayer(drawer);
    const btn = $('#cartBtn');
    if (btn) btn.addEventListener('click', e => { if (e.metaKey || e.ctrlKey || onCartPage()) return; e.preventDefault(); show(); });
    const ov = $('#overlay'); if (ov) ov.addEventListener('click', () => { hide(); closeLayer($('#mnav')); });
    drawer.addEventListener('click', async e => {
      if (e.target.closest('#cartClose')) { hide(); return; }
      const b = e.target.closest('[data-line-qty]'); if (!b) return;
      e.preventDefault();
      const line = b.closest('.line'), key = line && line.dataset.key; if (!key) return;
      const q = Math.max(0, parseInt(b.dataset.lineQty, 10) || 0);
      if (q === 0) line.classList.add('is-leaving');
      line.style.pointerEvents = 'none';
      try { await changeLine(key, q); if (q === 0) toast('Removed from cart'); }
      catch (err) { toast(err.message); line.classList.remove('is-leaving'); }
      finally { if (line.isConnected) line.style.pointerEvents = ''; }
    });
    window.ALLYU.openCart = show;
    /* Back/Forward can restore a page from memory with an old cart count and drawer: fetch the real cart */
    addEventListener('pageshow', e => { if (!e.persisted) return; if (onCartPage()) location.reload(); else refreshDrawer(); });
  }

  /* ----------------------------------------------------------------- header */
  function wireHeader() {
    const header = $('#header'); if (!header) return;
    const onScroll = () => header.classList.toggle('is-stuck', scrollY > 8);
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
    const hero = $('.hero');
    if (hero && document.body.classList.contains('page-home') && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => header.classList.toggle('show-logo', !en.isIntersecting), { rootMargin: '-35% 0px 0px 0px' }).observe(hero);
    } else header.classList.add('show-logo');

    const mega = $('#mega'), megaBtn = $('#megaBtn');
    if (mega && megaBtn) {
      let t;
      const set = v => { mega.classList.toggle('is-open', v); megaBtn.setAttribute('aria-expanded', v); };
      megaBtn.addEventListener('click', () => set(megaBtn.matches(':hover') || !mega.classList.contains('is-open')));   /* hover already opened it: a mouse click must not shut it */
      [megaBtn, mega].forEach(el => {
        el.addEventListener('mouseenter', () => { clearTimeout(t); set(true); });
        el.addEventListener('mouseleave', () => { t = setTimeout(() => set(false), 220); });
      });
    }
    const mnav = $('#mnav'), menuBtn = $('#menuBtn');
    if (mnav && menuBtn) {
      menuBtn.addEventListener('click', () => { openLayer(mnav, 'a'); menuBtn.setAttribute('aria-expanded', 'true'); });
      const c = $('#mnavClose'); if (c) c.addEventListener('click', () => closeLayer(mnav));
      mnav.addEventListener('click', e => { if (e.target === mnav) closeLayer(mnav); });
    }
    const spans = $$('.ann__rotator span'); let i = 0;
    if (spans.length > 1 && !CALM) setInterval(() => { spans[i].classList.remove('is-on'); i = (i + 1) % spans.length; spans[i].classList.add('is-on'); }, 3600);
  }

  /* ----------------------------------------------------------------- search */
  function wireSearch() {
    const box = $('#search'), input = $('#searchInput'), out = $('#searchOut'), btn = $('#searchBtn');
    if (!box || !input || !out || !btn) return;
    let t, n = 0;
    btn.addEventListener('click', () => openLayer(box, '#searchInput'));
    const close = $('#searchClose'); if (close) close.addEventListener('click', () => closeLayer(box));
    input.addEventListener('input', () => {
      clearTimeout(t);
      const id = ++n;
      const q = input.value.trim();
      if (!q) { out.innerHTML = '<p class="search__empty">Try “tee”, “hoodie”, or a color.</p>'; return; }
      t = setTimeout(async () => {
        try {
          const html = await fetch(`${R.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); });
          if (id !== n) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const inner = doc.querySelector('.shopify-section') || doc.body;
          out.innerHTML = inner.innerHTML.trim() || `<p class="search__empty">Nothing for “${esc(q)}”.</p>`;
          wireCards(out);
        } catch (e) { /* keep last results */ }
      }, 220);
    });
  }

  /* ------------------------------------------------------------ size guide */
  function wireModal() {
    const m = $('#sizeModal'); if (!m) return;
    m.addEventListener('click', e => { if (e.target === m || e.target.closest('[data-close]')) closeLayer(m); });
    document.addEventListener('click', e => { if (e.target.closest('[data-size-guide]')) { guideFromProduct(m); openLayer(m, '[data-close]'); } });
  }
  /* This product's own measurement table (TapStitch puts one in the description) wins over the "size-guide" page,
     which may still hold the June tables for discontinued pieces. No table on the product → the page shows as before. */
  function guideFromProduct(m) {
    const old = $('[data-guide-copy]', m); if (old) old.remove();
    const src = $('[data-pdp-section] .rte #size-guide') || $('[data-pdp-section] .rte table');
    $$('.modal__panel > .rte, .modal__panel > .table', m).forEach(n => { n.hidden = !!src; });
    if (!src) return;
    const box = document.createElement('div'); box.className = 'rte'; box.style.margin = '0 0 18px'; box.dataset.guideCopy = '';
    const t = src.cloneNode(true); t.removeAttribute('id'); $$('[id]', t).forEach(n => n.removeAttribute('id')); box.append(t);
    const head = $('.modal__head', m); if (head) head.after(box);
  }

  /* --------------------------------------------------------- product cards */
  function cardShowColor(card, c, i) {
    if (!c) return;
    const media = $('.card__media', card);
    let front = $('[data-card-front]', card);
    let back = $('[data-card-back]', card);
    if (c.img) {
      if (!front && media) {
        front = document.createElement('img'); front.className = 'card__front'; front.alt = ''; front.dataset.cardFront = '';
        const ph = $('.placeholder-svg', media); if (ph) ph.replaceWith(front); else media.append(front);
      }
      if (front) {
        front.src = c.img; front.removeAttribute('srcset'); front.hidden = false;
        const tl = $('[data-card-title-link]', card); if (tl) front.alt = tl.textContent.trim() + ' — ' + c.name;
      }
    } else if (front) front.hidden = true;
    if (c.img2 && front) {
      if (!back) { back = document.createElement('img'); back.className = 'card__back'; back.alt = ''; back.dataset.cardBack = ''; front.after(back); }
      back.src = c.img2; back.hidden = false;
    } else if (back) back.hidden = true;
    $$('[data-card-link], [data-card-title-link]', card).forEach(a => { a.href = c.url; });
    const pr = $('[data-card-price]', card); if (pr) pr.innerHTML = priceHTML(c.price, c.compare);
    const qc = $('[data-quick-color]', card); if (qc) qc.textContent = c.name;
    const qs = $('[data-quick-sizes]', card);
    const ttl = (($('[data-card-title-link]', card) || {}).textContent || '').trim();
    if (qs) qs.innerHTML = c.sizes.map(s => `<button type="button" data-variant-id="${s.id}" ${s.a ? '' : 'disabled aria-disabled="true"'} aria-label="Add ${esc(ttl)}, size ${esc(s.t)}">${esc(s.t)}</button>`).join('');
    $$('.sw', card).forEach(s => { const on = +s.dataset.ci === i; s.classList.toggle('is-on', on); s.setAttribute('aria-pressed', on); });
  }
  function wireCards(root = document) {
    $$('[data-card]', root).forEach(card => {
      if (card.dataset.wired) return; card.dataset.wired = '1';
      let colors = null;
      const j = $('[data-card-json]', card);
      if (j) { try { colors = JSON.parse(j.textContent); } catch (e) { colors = null; } }
      if (colors) {
        const i = colors.findIndex(c => c.h === card.dataset.handle && c.name === card.dataset.color);
        $$('.sw', card).forEach(s => { const on = +s.dataset.ci === Math.max(0, i); s.classList.toggle('is-on', on); s.setAttribute('aria-pressed', on); });
      }
      card.addEventListener('click', async e => {
        const sw = e.target.closest('.sw');
        if (sw) { e.preventDefault(); if (colors) cardShowColor(card, colors[+sw.dataset.ci], +sw.dataset.ci); return; }
        const b = e.target.closest('[data-variant-id]');
        if (!b || b.disabled) return;
        e.preventDefault(); b.disabled = true;
        try {
          await addToCart([{ id: +b.dataset.variantId, quantity: 1 }]);
          const title = ($('.card__title', card) || {}).textContent || '';
          toast(`Added · ${title.trim()}${b.textContent && b.textContent !== 'Add to cart' ? ' — ' + b.textContent.trim() : ''}`);
          if (window.ALLYU.openCart) window.ALLYU.openCart(b);
        } catch (err) { toast(err.message); }
        finally { b.disabled = false; }
      });
    });
    reveal(root);
  }

  /* ------------------------------------------------------------------ rails */
  function wireRail(rail) {
    if (rail.dataset.wired) return; rail.dataset.wired = '1';
    const sec = rail.closest('[data-rail-wrap]') || rail.parentNode;
    const prev = $('[data-prev]', sec), next = $('[data-next]', sec), bar = $('.rail-progress span', sec);
    const gap = () => parseFloat(getComputedStyle(rail).columnGap) || 20;
    const step = () => { const c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + gap() : rail.clientWidth; };
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      if (bar) {
        bar.parentNode.style.visibility = max > 4 ? '' : 'hidden';
        const vis = rail.clientWidth / Math.max(1, rail.scrollWidth);
        bar.style.width = Math.min(100, vis * 100) + '%';
        bar.style.transform = `translateX(${max > 0 ? (rail.scrollLeft / max) * ((1 - vis) / vis) * 100 : 0}%)`;
      }
    };
    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true }); addEventListener('resize', update); update();
    let down = false, sx = 0, sl = 0, moved = false;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = rail.scrollLeft; });
    addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 6) { moved = true; rail.classList.add('is-dragging'); } rail.scrollLeft = sl - dx; });
    addEventListener('pointerup', () => { if (!down) return; down = false; setTimeout(() => rail.classList.remove('is-dragging'), 0); });
    rail.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }

  /* ----------------------------------------------------------------- reveal */
  let io;
  function reveal(root = document) {
    const els = $$('.reveal:not(.is-in)', root);
    if (!('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    io = io || new IntersectionObserver(ents => ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(e => io.observe(e));
  }

  /* -------------------------------------------------------------- countdown */
  function wireCountdowns() {
    $$('[data-countdown]').forEach(el => {
      const end = Date.parse(el.dataset.countdown);
      if (isNaN(end)) { el.hidden = true; return; }
      const pad = n => String(n).padStart(2, '0');
      let timer = 0;
      const tick = () => {
        if (end <= Date.now()) {
          el.hidden = true; const lb = el.previousElementSibling; if (lb && lb.classList.contains('countdown__label')) lb.hidden = true;
          clearInterval(timer); return;
        }
        let s = Math.max(0, Math.floor((end - Date.now()) / 1000));
        const d = Math.floor(s / 86400); s -= d * 86400; const h = Math.floor(s / 3600); s -= h * 3600; const m = Math.floor(s / 60); s -= m * 60;
        el.innerHTML = [[d, 'Days'], [pad(h), 'Hours'], [pad(m), 'Min'], [pad(s), 'Sec']].map(([v, l]) => `<div><b>${v}</b><span>${l}</span></div>`).join('');
      };
      tick(); if (!el.hidden) timer = setInterval(tick, 1000);
    });
  }

  /* ----------------------------------------------------------- product page */
  function initPDP(wrap, opts) {
    wrap = wrap || $('[data-pdp-section]'); if (!wrap) return;
    const pdp = $('[data-pdp]', wrap), form = $('form[data-product-form]', wrap);
    let product;
    try { product = JSON.parse($('[data-product-json]', wrap).textContent); } catch (e) { return; }
    const idInput = $('[data-variant-id]', wrap), priceEl = $('[data-price]', wrap);
    const addBtn = $('[data-add]', wrap), addLabel = $('[data-add-label]', wrap);
    const colorName = $('[data-color-name]', wrap), hint = $('[data-size-hint]', wrap), qtyIn = $('[data-qty-input]', wrap);
    const colorInputs = $$('input[data-color]', wrap), sizeInputs = $$('input[data-size]', wrap);
    const colorIdx = colorInputs.length ? +colorInputs[0].dataset.optionIndex : -1;
    const sizeIdx = sizeInputs.length ? +sizeInputs[0].dataset.optionIndex : -1;
    const qty = () => Math.max(1, parseInt(qtyIn && qtyIn.value, 10) || 1);

    /* gallery */
    const slides = $$('.pdp__slide', wrap), thumbs = $$('.pdp__thumb', wrap);
    const track = $('[data-slides]', wrap), stage = $('[data-stage]', wrap), dots = $('[data-dots]', wrap), count = $('[data-count]', wrap);
    let visible = slides.map((_, i) => i), cur = 0;
    function go(i, smooth = true) {
      const n = visible.length || 1; cur = ((i % n) + n) % n;
      if (track) {
        track.style.transition = smooth ? '' : 'none';
        track.style.transform = `translateX(${-100 * cur}%)`;
        if (!smooth) requestAnimationFrame(() => { track.style.transition = ''; });
      }
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === visible[cur]));
      $$('i', dots).forEach((d, k) => d.classList.toggle('is-on', k === cur));
      if (count) count.textContent = n > 1 ? `${cur + 1} / ${n}` : '';
    }
    function filterGallery(color) {
      let v = [];
      if (color) {
        const want = color.toLowerCase().trim();
        v = slides.map((s, i) => (s.dataset.alt === want ? i : -1)).filter(i => i >= 0);
        if (!v.length && colorIdx >= 0) {
          /* each color's first photo = the photo attached to its variant (matched by media id); the color owns
             every photo from there up to the next color's photo */
          const indexOf = fm => { if (!fm) return -1; const byId = slides.findIndex(s => s.dataset.mediaId == String(fm.id)); return byId >= 0 ? byId : slides.findIndex(s => +s.dataset.position === fm.position); };
          const anchors = {};
          product.variants.forEach(x => { const c = x.options[colorIdx]; const i = indexOf(x.featured_media); if (i >= 0 && anchors[c] == null) anchors[c] = i; });
          const a0 = anchors[color];
          if (a0 != null) {
            const later = Object.values(anchors).filter(i => i > a0);
            const end = later.length ? Math.min(...later) : slides.length;
            v = slides.map((_, i) => (i >= a0 && i < end ? i : -1)).filter(i => i >= 0);
          }
        }
      }
      visible = v.length ? v : slides.map((_, i) => i);
      slides.forEach((s, i) => { s.hidden = !visible.includes(i); });
      thumbs.forEach((t, i) => { t.hidden = !visible.includes(i); });
      if (dots) dots.innerHTML = visible.length > 1 ? visible.map(() => '<i></i>').join('') : '';
      go(0, false);
      if (stage) { stage.classList.remove('is-swapping'); void stage.offsetWidth; stage.classList.add('is-swapping'); }
    }
    thumbs.forEach((t, i) => t.addEventListener('click', () => go(visible.indexOf(i))));
    const prev = $('[data-prev]', stage), next = $('[data-next]', stage);
    if (prev) prev.addEventListener('click', () => go(cur - 1));
    if (next) next.addEventListener('click', () => go(cur + 1));
    let sx = null;
    if (stage) {
      stage.addEventListener('pointerdown', e => { sx = e.clientX; });
      stage.addEventListener('pointerup', e => { if (sx == null) return; const dx = e.clientX - sx; sx = null; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); });
    }

    /* variants */
    const selection = () => product.options.map((_, i) => { const r = $(`input.opt-input[data-option-index="${i}"]:checked`, wrap); return r ? r.value : null; });
    const fits = (v, sel) => v.options.every((o, i) => sel[i] == null || o === sel[i]);
    const match = sel => product.variants.find(v => fits(v, sel) && v.available) || product.variants.find(v => fits(v, sel));
    const expressWrap = $('[data-express-wrap]', wrap), express = $('[data-express]', wrap);
    const otherInputs = $$('input.opt-input:not([data-color])', wrap);
    const exactVariant = sel => (sel.every(x => x != null) ? product.variants.find(x => fits(x, sel)) || null : null);
    function nudgeSize(msg) {
      if (hint) { hint.textContent = msg; hint.style.color = 'var(--ink)'; }
      const g = sizeInputs[0] && sizeInputs[0].closest('.sizes');
      if (g && g.animate && !CALM) g.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 320 });
    }
    function update(colorChanged) {
      let sel = selection();
      const color = colorIdx >= 0 ? sel[colorIdx] : null;
      if (colorName && color) colorName.textContent = color;
      /* grey out any size (or other option) that has no available variant with the rest of the selection */
      const soldOut = [];
      otherInputs.forEach(inp => {
        const idx = +inp.dataset.optionIndex;
        const test = sel.slice(); test[idx] = inp.value;
        const hit = product.variants.find(x => fits(x, test));
        const ok = !!(hit && hit.available);
        inp.disabled = !ok; if (inp.nextElementSibling) inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
        if (!ok) { if (inp.hasAttribute('data-size')) soldOut.push(inp.value); if (inp.checked) inp.checked = false; }
      });
      sel = selection();
      const v = match(sel), exact = exactVariant(sel);
      if (hint) { hint.style.color = ''; hint.textContent = soldOut.length ? `${soldOut.join(', ')} sold out${color ? ' in ' + color : ''}.` : ''; }
      if (v) {
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = priceHTML(v.price, v.compare_at_price, true);
        if (addBtn) addBtn.disabled = !v.available;
        if (addLabel) addLabel.innerHTML = v.available ? `Add to cart — ${money(v.price * qty())}` : 'Sold out';
      } else {
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
      }
      /* Shop Pay / Buy it now only once every option is picked and that exact variant is available */
      const expressOK = !!(exact && exact.available);
      if (expressOK && idInput) idInput.value = exact.id;
      /* tell Shopify's Buy it now / Shop Pay buttons and the installments banner that the variant changed (Dawn does the same) */
      if (idInput && idInput.dataset.sent !== idInput.value) { idInput.dataset.sent = idInput.value; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (expressWrap) expressWrap.classList.toggle('is-locked', !expressOK);
      if (express) express.inert = !expressOK;
      if (exact && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', exact.id); history.replaceState(history.state, '', u.href); }   /* keep utm_ / fbclid and any other params */
      if (colorChanged) filterGallery(color);
    }
    const lockBtn = $('[data-express-lock]', wrap);
    if (lockBtn) lockBtn.addEventListener('click', () => nudgeSize(sizeIdx >= 0 && !sizeInputs.some(i => i.checked) ? 'Choose a size first.' : 'That combination isn’t available.'));
    $$('input.opt-input', wrap).forEach(inp => inp.addEventListener('change', () => update(inp.hasAttribute('data-color'))));
    $$('[data-qty]', wrap).forEach(b => b.addEventListener('click', () => { if (!qtyIn) return; qtyIn.value = Math.min(99, Math.max(1, qty() + +b.dataset.qty)); update(false); }));
    if (qtyIn) qtyIn.addEventListener('change', () => update(false));

    if (form) form.addEventListener('submit', async e => {
      e.preventDefault();
      if (sizeIdx >= 0 && !sizeInputs.some(i => i.checked)) { nudgeSize('Choose a size first.'); return; }
      const exact = exactVariant(selection());
      if (!exact || !exact.available) { nudgeSize('That combination isn’t available.'); return; }
      if (addBtn) addBtn.disabled = true;
      try {
        await addToCart([{ id: exact.id, quantity: qty() }]);
        const sel = selection().filter(Boolean).join(' / ');
        toast(`Added · ${($('.pdp__title', wrap) || {}).textContent || ''}${sel ? ' — ' + sel : ''}`);
        if (window.ALLYU.openCart) window.ALLYU.openCart(addBtn);
      } catch (err) { toast(err.message); }
      finally { update(false); }
    });

    /* other products in the color group: swap the page in place */
    $$('a[data-sibling]', wrap).forEach(a => a.addEventListener('click', async e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      if (pdp) pdp.classList.add('is-loading');
      const keepSize = (sizeInputs.find(i => i.checked) || {}).value || null;
      try {
        const sid = pdp.dataset.sectionId;
        const url = a.href + (a.href.includes('?') ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
        const res = await fetch(url); if (!res.ok) throw new Error('load');
        const fresh = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('[data-pdp-section]');
        if (!fresh) throw new Error('load');
        wrap.replaceWith(fresh);
        if (history.replaceState) history.replaceState(null, '', a.href);
        initPDP(fresh, { size: keepSize });
        if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) window.Shopify.PaymentButton.init();   /* draw Buy it now / Shop Pay in the swapped-in form */
      } catch (err) { location.href = a.href; }
    }));

    /* after a color-group swap, keep the size the shopper already picked (the link's variant would preselect one) */
    if (opts && 'size' in opts) sizeInputs.forEach(i => { i.checked = opts.size != null && i.value === opts.size; });
    update(true);
  }

  async function loadRecs() {
    const el = $('[data-recs]'); if (!el || !el.dataset.url || el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then(r => r.text());
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; wireCards(el); $$('[data-rail]', el).forEach(wireRail); }
    } catch (e) { /* no recommendations */ }
  }

  /* -------------------------------------------------------------------- keys */
  function wireKeys() {
    document.addEventListener('keydown', e => {
      if (e.key !== 'Escape') return;
      const top = open[open.length - 1]; if (top) closeLayer(top);
      const mega = $('#mega'), mb = $('#megaBtn'); if (mega) mega.classList.remove('is-open'); if (mb) mb.setAttribute('aria-expanded', 'false');
    });
  }

  /* -------------------------------------------------------------------- boot */
  function boot() {
    window.ALLYU = Object.assign(window.ALLYU || {}, { addToCart, toast, money });
    initLayers(); wireHeader(); wireCart(); wireSearch(); wireModal(); wireKeys();
    wireCards(); $$('[data-rail]').forEach(wireRail); wireCountdowns(); initPDP(); loadRecs(); reveal();
    let readyDone = false;
    const ready = () => { if (readyDone) return; readyDone = true; requestAnimationFrame(() => document.documentElement.classList.add('is-loaded')); };
    const heroImgs = $$('.hero__panel img');
    if (heroImgs.length) { Promise.all(heroImgs.map(i => (i.decode ? i.decode() : Promise.resolve()).catch(() => {}))).then(ready); setTimeout(ready, 800); }
    else ready();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* theme editor: re-run when sections are added/changed */
  document.addEventListener('shopify:section:load', e => { wireCards(e.target); $$('[data-rail]', e.target).forEach(wireRail); wireCountdowns(); reveal(e.target); });
})();
